module.exports = __webpack_public_path__ + "res/materialdesignicons-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/lumx/fonts/materialdesignicons-webfont.svg?v=1.9.32
// module id = 111
// module chunks = 1